import { render, staticRenderFns } from "./DualRangeSlider.vue?vue&type=template&id=0fabbaa3&scoped=true&"
import script from "./DualRangeSlider.vue?vue&type=script&lang=js&"
export * from "./DualRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./DualRangeSlider.vue?vue&type=style&index=0&id=0fabbaa3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabbaa3",
  null
  
)

export default component.exports